export const TimeKeepingEN = {
    "timeSheet": "Time Sheet",
    "shiftSchedule": "Shift Schedule",
    "shiftAssignment": "Shift Assignment",
    "meals": "Meals",
    "leaveManagement": "Leave Management",
    "autoInout": "Auto Inout",
    "casualAndCompensatory": "Casual And Compensatory",
    "casualLeave": "Casual Leave",
    "compensatoryLeave": "Compensatory Leave"
}